import React from 'react';
import { Button, Carousel, Container } from 'react-bootstrap';
import { BiLinkExternal } from 'react-icons/bi';
import Particle from '../../Particle';


import mansionHome from "../../../Images/Project/mansion/mansion-home.JPG";
import mansionApartment from "../../../Images/Project/mansion/mansion-apartments.JPG";
import mansionReview from "../../../Images/Project/mansion/mansion-review.JPG";
import mansionDashboard from "../../../Images/Project/mansion/mansion-dashboard.JPG";

const Mansion = () => {
    return (
        <Container fluid className="project-section">
            <Particle />
            <Container>
                <h1 className="project-heading">
                    Mansion Residence <strong className="purple"> Website </strong>
                </h1>
                <div className='mt-5 mb-5'>
                    <div className='container '>
                        <div className='row '>
                            <div className='col-lg-6 col-sm-12'>
                                <Carousel fade>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={mansionHome}
                                            alt="First slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={mansionApartment}
                                            alt="Second slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={mansionReview}
                                            alt="Third slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item interval={1000}>
                                        <img
                                            style={{ height: '300px' }}
                                            className="d-block w-100"
                                            src={mansionDashboard}
                                            alt="fourth slide"
                                        />
                                    </Carousel.Item>
                                </Carousel>

                            </div>
                            <div className='col-lg-6 col-sm-12'>
                                <p className='fw-bold text-white'>This is a Full-Stack Apartmnet rental website.User can Select any apartment for rent and booked the apartment. </p>

                                <p className='text-white'>
                                    <ul>
                                        <li>User must need to Login via creating an free account.</li>
                                        <li>User and Admin Dashboard.</li>
                                        <li>User can can Cancle his booking and can give reviews.</li>
                                        <li>Admin can manage the booking and add new apartments.</li>
                                    </ul></p>
                                <p className='text-white'> Front-end technology: React js, Bootstrap, React Router, Firebase Authentication</p>
                                <p className='text-white'> Back-end technology: Node js,Express js, MongoDB</p>
                                <Button href='https://github.com/nhnajmul17/Mansion-Client' style={{ marginRight: '3px' }} className='btn btn-info '>  <BiLinkExternal /> &nbsp;Client Side</Button>
                                <Button href='https://github.com/nhnajmul17/Mansion-Server' style={{ marginRight: '3px' }} className='btn btn-info  '>  <BiLinkExternal /> &nbsp;server Side</Button>
                                <Button href='https://mansion-residence.web.app/' className='btn btn-info'>  <BiLinkExternal /> &nbsp;Live Site</Button>

                            </div>

                        </div>

                    </div>


                </div>


            </Container>
        </Container>
    );
};

export default Mansion;